import ccEcharts from '@/components/common/echarts/echarts-base.vue';
import echarts from 'echarts';
export default {
    name: 'bar-echarts',
    components: {ccEcharts},
    props: {
        id: {
            type: String,
            default: ''
        },
        data:{
            type:Array,
            default() {
                return [];
            }
        }
    },
    watch: {
        data: {
            deep: true,
            handler(val) {
                this.echartsData = val;
                this.initOptions();
            }
        }
    },
    data() {
        return {
            echartsData:this.data,
            options:{
                grid:{
                    top: '15%',
                    bottom: '30%',
                    left:80,
                    right:40
                },
                xAxis: {
                    data: [],
                    axisTick: {show: false},
                    axisLine: {show: false},
                    axisLabel: {
                        show: true,
                        margin: 50,
                        align: 'center',
                        textStyle: {
                            fontSize: 16,
                            color: '#40444d'
                        }
                    },
                    interval: 0
                },
                yAxis: {
                    position:'left',
                    splitLine: {show: false},
                    axisTick: {show: false},
                    axisLine: {show: false},
                    axisLabel: {
                        show: true,
                        margin: 0,
                        interval: 0,
                        min: 0,
                        verticalAlign:'top',
                        align: 'center',
                        textStyle: {
                            fontSize: 18,
                            color: '#40444d'
                        }
                    },
                    offset:40
                },
                series: [{
                    name: 'top',
                    type: 'pictorialBar',
                    symbolSize: [26, 10],
                    symbolOffset: [0, -5],
                    z: 12,
                    itemStyle: {normal: {color: '#FF774C'}},
                    label: {
                        show: true,
                        position: 'top',
                        fontSize: 16
                    },
                    symbolPosition: 'end',
                    data: []
                }, {
                    name: 'bottom',
                    type: 'pictorialBar',
                    symbolSize: [26, 10],
                    symbolOffset: [0, 5],
                    z: 12,
                    itemStyle: {normal: {color: '#FBC869'}},
                    data: []
                }, {
                    type: 'bar',
                    itemStyle: {
                        normal: {
                            color: function () {
                                return new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [{
                                        offset: 1,
                                        color: '#FFC047 '
                                    },
                                    {
                                        offset: 0,
                                        color: '#FF774C'
                                    }
                                    ]
                                );
                            },
                            opacity: 1
                        }
                    },
                    z: 16,
                    silent: true,
                    barWidth: 26,
                    barGap: '-100%',
                    data: []
                }]
            }
        };
    },
    mounted() {
        this.initOptions();
    },
    methods: {
        // 处理options
        initOptions() {
            const _this = this;
            const xAxisData = [];
            _this.echartsData.forEach(item => {
                xAxisData.push(item.name);
            });
            this.options.xAxis.data = xAxisData;
            this.options.series.forEach(item => {
                item.data = _this.echartsData;
            });
        }

    }
};
